export class GetMetricFields {
  public static readonly type: string = '[NewMetrics] Get new metric - metric fields';
}

export class GetMetricLabels {
  public static readonly type: string = '[NewMetrics] Get new metric - metric labels';
}
